export const CVReview_1075 = [
	'overview',
	'subject',
	'neighborhood',
	'projectanalysis',
	'projectinformation',
	'unitdescription',
	'comps',
	'salesapproach',
	'incomeapproach',
	'reconciliation',
	'pdfreview',
	'photoreview',
	'helpcenter'
];
